import config from './default';
import { Config } from './util';

export default config as Config;
